import { frontendURL } from '../../../helper/URLHelper';
import { LAIS_AGENT_PERMISSIONS } from '../laisRouteHelpers';

const meta = { permissions: LAIS_AGENT_PERMISSIONS };

const redirectTo = routeName => to => ({
  name: routeName,
  params: to.params,
  query: to.query,
});

export const routes = [
  {
    path: frontendURL('accounts/:accountId/imobiliario'),
    alias: [frontendURL('accounts/:accountId/real-estate')],
    name: 'real_estate_index',
    redirect: redirectTo('inicio_index'),
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imobiliario/imoveis'),
    name: 'real_estate_imoveis_redirect',
    redirect: redirectTo('imoveis_index'),
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imobiliario/clientes'),
    name: 'real_estate_clientes_redirect',
    redirect: redirectTo('lais_clients_grouped'),
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imobiliario/visitas'),
    name: 'real_estate_visitas_redirect',
    redirect: redirectTo('visitas_index'),
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imobiliario/ofertas'),
    name: 'real_estate_ofertas_redirect',
    redirect: redirectTo('lais_tenants_rent_flows'),
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imobiliario/locacao'),
    name: 'real_estate_locacao_redirect',
    redirect: redirectTo('lais_meu_aluguel_index'),
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imobiliario/qpreco'),
    name: 'real_estate_qpreco_redirect',
    redirect: redirectTo('lais_area_qpreco_index'),
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/imobiliario/financeiro'),
    name: 'real_estate_financeiro_redirect',
    redirect: redirectTo('operacao_imobiliaria_financeiro'),
    meta,
  },
];
